import moment from 'moment';

import { DecimalPlacesPipe } from '../../../../shared/pipes/decimal-places.pipe';

const dateValueFormatter = (value :string, format :string = 'MMM DD, YYYY') => {
  if (!value) {
    return '';
  }

  return moment(value).format(format);
};

const decimalPlacesFormatter = (value :number) => {
  const decimalPlacesPipe = new DecimalPlacesPipe();

  return decimalPlacesPipe.transform(value).toString();
};

export const FulfillmentOrdersValueFormatterUtils = {
  dateValueFormatter,
  decimalPlacesFormatter,
};
